import Footer from "../../components/Footer/Footer"
export default function FooterPage() {
    return <Footer/>
}